import React from "react";
import ActionButton from "./ActionButton";
import styled from "styled-components";

export const SECTION_KEYS = {
  DUPSUB: "dupsub",
  CLEARSKIES: "clearskies",
  PUBPEER: "pubpeer",
  REFERENCE_ANALYSIS: "reference",
  METADATA_ANALYSIS: "metadata",
  TEXT_ANALYSIS: "text",
  SIGNALCHECK: "signalCheck",
  CONDUCTCHECK: "conductCheck",
  ALL: "all",
};

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  max-width: 100px;
`;

// Retrieve MDB primary and secondary colors
const rootStyles = getComputedStyle(document.documentElement);
const dupSubColor = rootStyles.getPropertyValue("--mdb-primary").trim();
const signalCheckColor = "#6b7280";
const conductCheckColor = "#6b7280";
const clearSkiesColor = "#ff69b4";
const textAnalysisColor = "#800080";
const referenceAnalysisColor = rootStyles.getPropertyValue("--mdb-warning").trim();
const metadataAnalysisColor = rootStyles.getPropertyValue("--mdb-info").trim();
const pubPeerColor = "#d35400";

export const ReportActionButtons = ({
  signals,
  onIconClick = () => {},
  showTooltip = true,
  iconOnly = false,
}) => {
  const buttonConfigs = [
    {
      key: SECTION_KEYS.DUPSUB,
      shouldShow: signals?.includes("duplicateSubmissions"),
      title: showTooltip ? "Match in Duplicate submissions, click for report" : "",
      color: dupSubColor,
      icon: "copy",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.SIGNALCHECK,
      shouldShow: signals?.some((signal) => signal.startsWith("signalCheck")),
      title: showTooltip ? "SignalCheck match found, click for details" : "",
      color: signalCheckColor,
      icon: "eye",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.CONDUCTCHECK,
      shouldShow: signals?.some((signal) => signal.startsWith("conductCheck")),
      title: showTooltip ? "ConductCheck match found, click for details" : "",
      color: conductCheckColor,
      icon: "user",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.CLEARSKIES,
      shouldShow: signals?.includes("papermillSimilarity"),
      title: showTooltip ? "ClearSkies report available, click to open" : "",
      color: clearSkiesColor,
      icon: "bell",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.TEXT_ANALYSIS,
      shouldShow: !!signals?.some((signal) =>
        ["torturedPhrases", "suspectPhrases", "genAIResponse", "geppetto"].includes(signal)
      ),
      title: showTooltip ? "Text report available, click to open" : "",
      color: textAnalysisColor,
      icon: "file-alt",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.REFERENCE_ANALYSIS,
      shouldShow: !!signals?.some((signal) =>
        ["retractionWatch", "doiAnalysis", "crossrefChecks", "contextChecks"].includes(signal)
      ),
      title: showTooltip ? "Suspicious references, click for report" : "",
      color: referenceAnalysisColor,
      icon: "exclamation-triangle",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.METADATA_ANALYSIS,
      shouldShow: signals?.includes("wordFileMetadata"),
      title: showTooltip ? "Metadata report available, click to open" : "",
      color: metadataAnalysisColor,
      icon: "file-word",
      onClick: onIconClick,
    },
    {
      key: SECTION_KEYS.PUBPEER,
      shouldShow: signals?.includes("pubPeerHits"),
      title: showTooltip ? "PubPeer report available, click to open" : "",
      color: pubPeerColor,
      icon: "search",
      onClick: onIconClick,
    },
  ];

  const visibleButtons = buttonConfigs.filter((btn) => btn.shouldShow);
  if (visibleButtons.length === 0) {
    return null;
  }

  return (
    <ButtonContainer>
      {visibleButtons.map(({ key, onClick, ...btnProps }) => (
        <ActionButton
          key={key}
          onClick={() => onClick(key)}
          iconOnly={iconOnly}
          {...btnProps}
        />
      ))}
    </ButtonContainer>
  );
};
